export const games = {
    yx: 'Jeux',
    yxms: 'Dans les jeux cryptés, tous les résultats sont générés à l avance sous forme de hachage, et ne peuvent être modifiés par quiconque, garantissant une équité absolue !',
    mnsm: 'Essai gratuit',
    ljqw: 'Jouer maintenant',
    loading: 'Chargement, veuillez patienter',
    dyh: 'Divers contrats d options à votre choix, rendements centuplés, taux de retour élevé à court terme',
    qyhy:'Contrats d options',
    qsyhys:'Options',
    kd:'Ouvrir une position',
    qt:'Divertissement',
    ljjy: "Trader maintenant",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/fr.js